import { formatDateSafe } from '@/utils/dateUtils';
import { MONTHS_TO_ENTITLEMENT, STAGE_COPY } from './acquisitionProgress.definitions';
import type { AcquisitionProgressProps } from './acquisitionProgress.types';

export function AcquisitionProgress({
    stage,
    monthsWorked,
    entitledFrom,
    admissionDate,
    canRequestFrom,
}: AcquisitionProgressProps) {
    const months = Math.min(monthsWorked, MONTHS_TO_ENTITLEMENT);
    const percentage = Math.round((months / MONTHS_TO_ENTITLEMENT) * 100);

    const copy = STAGE_COPY[stage];
    const bodyDate = stage === 'tooEarly' ? canRequestFrom : entitledFrom;

    return (
        <div className="rounded-xl border border-primary-200 bg-primary-50 p-6">
            <div className="flex items-baseline justify-between">
                <p className="text-sm font-medium text-raro-gray-700 font-montserrat">
                    Período aquisitivo em andamento
                </p>
                <p className="text-sm text-raro-gray-500 font-montserrat">
                    {months} / {MONTHS_TO_ENTITLEMENT} meses
                </p>
            </div>

            <div
                className="mt-3 h-2 w-full overflow-hidden rounded-full bg-white"
                role="progressbar"
                aria-valuenow={months}
                aria-valuemin={0}
                aria-valuemax={MONTHS_TO_ENTITLEMENT}
                aria-label="Progresso do período aquisitivo"
            >
                <div
                    className="h-full rounded-full bg-primary-500 transition-all duration-300"
                    style={{ width: `${percentage}%` }}
                />
            </div>

            <div className="mt-4 text-center">
                <p className="text-base font-semibold text-raro-gray-900 font-montserrat">
                    {copy.title}
                </p>
                {bodyDate && (
                    <p className="mt-1 text-sm text-raro-gray-600 font-montserrat">
                        {copy.body(formatDateSafe(bodyDate))}
                    </p>
                )}
                {admissionDate && (
                    <p className="mt-1 text-xs text-raro-gray-500 font-montserrat">
                        Admissão em {formatDateSafe(admissionDate)}
                    </p>
                )}
            </div>
        </div>
    );
}

export default AcquisitionProgress;
